<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="RankProgressAdvanced" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import RankProgressAdvanced from './RankProgressAdvanced.vue';

import { useChangableProps } from '@/composables/useChangableProps';
import {AdvancedRankProgressProps} from "@/components/ui/RankProgressAdvanced.ts";

const componentName = 'ui-rank-progress-advanced';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<AdvancedRankProgressProps>();
const changableProps = useChangableProps(componentName, props);

</script>
